import React from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { AuctionModuleService } from '../../services/AuctionModuleService';
import { allowance, approveTokens } from '../../web3Helper';
import { getNetwork } from '../../web3Utils';
import { toast } from 'react-toastify';

const AuctionModal = ({toggle, onCloseModal, inventory}) => {
    const [value, setValue] = React.useState(0);
    const [approvalAmount, setApprovalAmount] = React.useState(0);
    const [bidValue, setBidValue] = React.useState(0);
    const [isApprovalInProgress, setIsApprovalInProgress] = React.useState(false);
    const [isPlacingBidInProgress, setIsPlacingBidInProgress] = React.useState(false);

  const checkAllowance = async () => {

    const auctionModuleService = new AuctionModuleService();

    if(!value) return toast.error('Purchase Unavailable!');
   
    const allowanceAmount = await allowance({ spenderContractType: auctionModuleService.contractType });

    if(allowanceAmount < value) {
      setApprovalAmount(value - allowanceAmount);
    }
    setBidValue(value)
  }

  const handleApproval = async () => {

    const auctionModuleService = new AuctionModuleService();

    setIsApprovalInProgress(true);
    try {
      await approveTokens({ value: 1000000, spenderContractType: auctionModuleService.contractType });
      setIsApprovalInProgress(false);
      setApprovalAmount(0);
    } catch(err) {
      setIsApprovalInProgress(false);
      setApprovalAmount(0);
      setBidValue(0)
    } 
  }

  
  const handlePlaceBid = async () => {

    const auctionModuleService = new AuctionModuleService();
    const networkId = await getNetwork();
    const tokenId = inventory && inventory['tokenId'][networkId];

    setIsPlacingBidInProgress(true);
    auctionModuleService.placeBid({
      tokenId,
      value: bidValue,
    }).then(() => {
      setBidValue(0);
      setIsPlacingBidInProgress(false);
      onCloseModal();
      toast.success("Bid Placed Successfully!");
    }).catch((err) => {
      setBidValue(0);
      setIsPlacingBidInProgress(false);
      toast.error(err);
    })
  }

  return (
    <Modal open={ toggle } onClose={onCloseModal} closeOnOverlayClick={false}  classNames={ {
      overlay: 'customOverlay',
      modal: 'modal-1' 
    } } center>
      <h5 className='mx-3'>Place bid for the NFT Auction!</h5>
      <button onClick={onCloseModal} className="btn position-absolute top-0 end-0">X</button>
      <div className='mt-4'>
        <input 
          className={`form-control mb-3`}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Offer Value" 
        />
        {
          approvalAmount ? 
            <button onClick={()=> handleApproval()} className="btn buy" disabled={isApprovalInProgress} >
              { isApprovalInProgress ? 'Please Wait!' : `Approve` }
            </button>
          : bidValue ?
            <button onClick={()=> handlePlaceBid()} className="btn buy" disabled={isPlacingBidInProgress}>
              { isPlacingBidInProgress ? 'Please Wait!' : `Confirm Placing Offer ${bidValue} Tokens`}
            </button>
          :
          <button onClick={()=> checkAllowance()} className="btn buy">
            { 'Place Offer' }
          </button>
        }
      </div>
    </Modal>
  )
}
export default AuctionModal;